import Link from 'next/link';
import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
export const PrivacyPolicyPage = () => {
  return <>
      <PageSeo title="Legal Notice" description="Legal Notice. English language for professional communication and success on international scene." noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Privacy Policy</h1>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <p>
            This Privacy Policy explains how third-party services collect and process data when you use our website. By
            accessing or using this website, you agree to the practices outlined in this policy.
          </p>

          <h2 className="mt-5 font-bold">1. Data Controller</h2>
          <p>
            The data collected on this website is processed by third-party services such as Google Analytics and Yandex
            Metrics. We do not store or control this data on our servers. These third-party services act as independent
            data controllers, and their respective privacy policies govern their data processing practices.
          </p>

          <h2 className="mt-5 font-bold">2. Data Collected by Third-Party Services</h2>
          <p>The following data may be collected and processed by Google Analytics and Yandex Metrics:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Browsing data, such as IP address, browser type, and pages visited.</li>
            <li>Cookie identifiers and device information.</li>
            <li>Behavioral data, such as session duration and interactions on the website.</li>
          </ul>

          <h2 className="mt-5 font-bold">2.1 Data Collected by the Feedback Form (Telegram)</h2>
          <ul className="list-inside list-disc space-y-1">
            <li>
              When you submit a request via the website feedback form, the information you provide (such as your name,
              contact details, and message content) is immediately transmitted to our private Telegram channel. We do
              NOT store these data on our servers. Telegram acts as an independent data controller for your personal
              data upon transmission. For information on how Telegram processes and protects your data, please refer to
              the{' '}
              <Link target="_blank" rel="noopener noreferrer" className="text-brand-accent-normal underline" href="https://telegram.org/privacy/">
                Telegram Privacy Policy.
              </Link>
            </li>
            <li>
              By submitting a request through the feedback form, you consent to this transfer and acknowledge that your
              data will be accessible to the administrators of the receiving Telegram channel. Data processed by
              Telegram is subject to their internal policies and may be stored or transferred outside of the European
              Union, in accordance with their privacy policy.
            </li>
          </ul>

          <h2 className="mt-5 font-bold">3. Purpose of Data Collection</h2>
          <p>The collected data is used for:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>Analyzing website traffic and user behavior.</li>
            <li>Improving website functionality and user experience.</li>
          </ul>

          <h2 className="mt-5 font-bold">4. Cookies Used</h2>
          <p>This website uses cookies to facilitate analytics by third-party services. The cookies include:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>
              <strong>Google Analytics:</strong> Tracks user behavior on the website.
            </li>
            <li>
              <strong>Yandex Metrics:</strong> Monitors website performance and user actions.
            </li>
          </ul>
          <p>
            You can manage or disable cookies in your browser settings. However, disabling cookies may affect website
            functionality.
          </p>

          <h2 className="mt-5 font-bold">5. Your Rights</h2>
          <p>As the data is processed by third-party services, you can exercise your rights directly with them:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>
              Google Analytics: Visit the{' '}
              <Link target="_blank" rel="noopener noreferrer" className="text-brand-accent-normal underline" href="https://tools.google.com/dlpage/gaoptout">
                Google Analytics Opt-out Page
              </Link>
              .
            </li>
            <li>
              Yandex Metrics: Refer to the{' '}
              <Link target="_blank" rel="noopener noreferrer" className="text-brand-accent-normal underline" href="https://yandex.com/support/metrica/general/gdpr.html">
                Yandex Metrics GDPR Information
              </Link>
              .
            </li>
            <li>
              To exercise your rights regarding data submitted via the feedback form, please refer directly to the{' '}
              <Link target="_blank" rel="noopener noreferrer" className="text-brand-accent-normal underline" href="https://telegram.org/privacy/">
                Telegram Privacy Policy
              </Link>{' '}
              and contact Telegram if needed.
            </li>
          </ul>

          <h2 className="mt-5 font-bold">6. Changes to This Policy</h2>
          <p>
            We reserve the right to update this Privacy Policy. The latest version will always be available on our
            website.
          </p>
        </section>
      </Article>
    </>;
};
PrivacyPolicyPage.Layout = MainLayout;